/*
 * Horizontal rule component
 */

import React from 'react';

import Base from './base.jsx'; 
import { Mode } from '../common.jsx';

export default class PdfPageBreak extends Base {

        static get ANSWER_DEPENDENT() {
          return false
        }

        static get CATEGORY() {
            return 'layout';
        }

        static get TYPE() {
            return 'page_break';
        }

        static icon(){
            return <i className="fa fa-minus"></i>;
        }

        renderView() {
          if (this.props.mode == Mode.EDIT) {
            return <div className='fe-pdf-page-break'><span>PAGE-BREAK</span></div>
          }
          return (
              <div className='page-break-before' />
          );
        }

        renderSettings() {
          return <span>{I18n.t('component_page_break_description', {scope: 'fe'})}</span>
        }
}
